/**
 * SFrame131 – IAD Step 7: Obtain Allowance and Copy of the Will
 * Figma Frames 31-32
 *
 * Pulls planner's legal documents (Frame144, Frame260-261) as read-only if available.
 */

import { SettlementStepPage } from '../settlement';
import { SETTLEMENT_PHASE_CONFIGS } from '../../utils/settlementFlowConfig';

const step = SETTLEMENT_PHASE_CONFIGS['iad'].steps.find((s) => s.id === 'iad-7')!;

export default function SFrame131() {
  return (
    <SettlementStepPage
      step={step}
      phase="iad"
      overviewRoute="/sframe-141"
      plannerFrameIds={['frame-144', 'frame-260', 'frame-261']}
    />
  );
}
